import { Router } from "@reach/router"
import { Suspense, lazy } from "react"

import { ClientOnly, Spinner } from "@trueskin-web/components"
import { StoreJwtFromUrl } from "@trueskin-web/components/src/store-jwt-from-url"
import { Routes } from "@trueskin-web/translations"

import ErrorBoundary from "../app/components/error-boundary"

const FunnelApp = lazy(() => import("../app"))

const App = () => (
  <ClientOnly>
    <Suspense fallback={<Spinner isFullPage />}>
      <ErrorBoundary>
        <StoreJwtFromUrl />

        <Router basepath={Routes.App.path}>
          <FunnelApp default />
        </Router>
      </ErrorBoundary>
    </Suspense>
  </ClientOnly>
)

export default App
